// extracted by mini-css-extract-plugin
export default {"companyContainer":"UL-z","companyImage":"VL-z","container":"WL-z","heading":"XL-z","darkText":"YL-z","smallHeading":"ZL-z","darkBackground":"_L-z","whiteBackground":"aM-z"};